import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import * as userRegistrationsActions from '../actions/userRegistrations';
import * as sitesActions from '../actions/sites';
import InProgressRegistrationsTable from '../components/InProgressRegistrationsTable';
import { Roles } from '../models/roles';
import { currentlyLoggedInOrImpersonatingUserHasAnyRoleInCurrentlySelectedSite } from '../services/auth';
import useActiveSite from '../hooks/useActiveSite';

const InProgressRegistrationsListView = () => {
  const dispatch = useDispatch();
  const activeSite = useActiveSite();
  const userRegistrations = useSelector(state => state.entities.userRegistrations);
  const userRegistrationsList = userRegistrations.allIds.map(
    userRegistrationId => userRegistrations.byId[userRegistrationId]
  );
  const users = useSelector(state => state.entities.sites.users);
  const deleteUserRegistration = userRegistrationId => dispatch(userRegistrationsActions.deleteUserRegistration(userRegistrationId));

  const isAdmin = currentlyLoggedInOrImpersonatingUserHasAnyRoleInCurrentlySelectedSite([
    Roles.Admin,
    Roles.NationalSiteDirector,
  ]);

  // Filter by site and tos accepted for SD access
  const userRegistrationsFilteredList = userRegistrationsList
    .filter((user) => user.tos_accepted)
    .filter((user) => (activeSite.zip_codes || []).find((zipCode) => zipCode === user.zip_code));

  useEffect(() => {
    dispatch(userRegistrationsActions.fetchUserRegistrationsIfNeeded());
    dispatch(sitesActions.fetchSiteUsersIfNeeded(activeSite.id));
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <InProgressRegistrationsTable
          tableId="#user-registrations/in-progress-registrations"
          isLoading={userRegistrations.inflight || users.inflight}
          userRegistrations={isAdmin ? userRegistrationsList : userRegistrationsFilteredList}
          deleteUserRegistration={deleteUserRegistration}
        />
      </Grid>
    </Grid>
  );
};

export default InProgressRegistrationsListView;
